module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC/SURBVHgBxdTNDYIwGAbgt00HcABlFrlAmEKdhDqJOgUpHIwT6AhGF/AutBbiAU2xX9HE9wSFPF//gX9lWhRzVztHQKKqyhnn+1lZbkZDLWK0lt1L0xzevzMQ8oJovbpm2TYYoiBeiIq04T6EMXbzIYM96iO2UnxOkhM8Ec5WrbsCxhjc6xqUOId2SVNppbV9nHAhjpFSC3jyebKVkgbInz8ubYHdKCgEo21IAkaCKBj5rPUWABaM8W2GrpGf5QHJHGvXx/KN4wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fanclub/arrow_green.png
// module id = gpqZ
// module chunks = 1